import { Component, OnInit, TemplateRef } from '@angular/core';
//import { CostCenter } from './costcenter/costcenter';
import { CostCenter } from '../costcenter/costcenter';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { CostcenterService } from '../costcenter/costcenter.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-costcenter',
  templateUrl: './costcenter.component.html',
  styleUrls: ['./costcenter.component.css']
})
export class CostcenterComponent implements OnInit {

 sendMenuId: 34;
  sendPageName: string = 'Cost Center';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  costcenterForm: FormGroup;
  costcenters: CostCenter[] = [];
  costcentersactive: CostCenter[] = [];
  costcenter: CostCenter;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  costCenterModalRef: BsModalRef;
  operation: string;
  userid: number;
  branchid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }
  showall: boolean = true;
  showallstatus: boolean = false;

  key: string = 'costcenter'; //set default
  reverse: boolean = false;

  constructor(
    private costcenetrservice: CostcenterService,
    private costcenetrmodalService: BsModalService,
    private costcenetrformbuilder: FormBuilder,
    private router: Router, private costcenterservice: CostcenterService,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {      
      localStorage.setItem('Branch_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Branch_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Branch_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Branch_action');
    } 
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    // console.log(this._menuId); console.log(this._actionRights);
  
    this.costcenterForm = this.costcenetrformbuilder.group({
      costcenterid: [''],
      costcenter: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedcostcenter");
    let data = arrays.find(ob => ob['name'] === 'Cost Center');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedcostcenter","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedcostcenter",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.costCenterModalRef.hide();
  }
    
  get g() { return this.costcenterForm.controls; }

  getAll() {
    this.costcenters = [];
    this.costcentersactive = [];
    this.costcenterservice.Get().subscribe(res => {
      this.costcenters = res;
      if (this.showallstatus == true) {
        this.costcenters.forEach(data => {
          if (data.active == 1) {
            this.costcentersactive.push(data);
          }
        });
        this.costcenters = [];
        this.costcenters = this.costcentersactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });
    
    
  }

  getactiveinactive(showallp) {
    this.costcentersactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.costcenters.forEach(data => {
        if (data.active == 1) {
          this.costcentersactive.push(data);
        }
      });
      this.costcenters = [];
      this.costcenters = this.costcentersactive;
    }
    else {
      this.showall = true;
      this.costcenters = [];
      this.getAll();
    }
  }

  Post(costcenter: CostCenter) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.costcenterForm.invalid) {
    //  //console.log(this.g);
    //  console.log(this.costcenterForm.errors);
    //}
   
    if ((costcenter.costcenter.trim() == undefined) || (costcenter.costcenter.trim() == '')) {
      this.toastr.error('costcenter should not be empty');
      return;
    }
   
    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    costcenter.costcenter = costcenter.costcenter.trim();
    if (this.operation == 'add') {

      costcenter.createdby = this.userid;
      msg = "Record Added Successfully";
      this.costcenetrservice.Post(costcenter).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.costCenterModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      costcenter.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.costcenetrservice.Put(costcenter).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.costCenterModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.costcenterForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.costcenterForm.value.active = 1;
    } else {
      this.costcenterForm.value.active = 0
    }
  }

  OpenConfirmTemplate(costcenter, template: TemplateRef<any>) {
    if (costcenter.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.costcenter = costcenter;

          this.Delete();

        }
       
      });

  }
  
  Delete() {

    var msg;
    if (this.costcenter.active == 0) {
      this.costcenter.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.costcenter.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.costcenter.modifiedby = this.userid;

    this.costcenetrservice.Delete(this.costcenter).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }
   
  hidePopup() {
    this.costCenterModalRef.hide();
  }

  openCostCenterchModal(template: TemplateRef<any>, type, costcenter?: CostCenter) {
    
    
    this.operation = type
    if (type == 'update') {
      this.costcenterForm.controls['costcenterid'].setValue(costcenter.costcenterid);
      this.costcenterForm.controls['costcenter'].setValue(costcenter.costcenter);
      this.costcenterForm.controls['active'].setValue(costcenter.active);
      this.costcenter = costcenter;
    }
    if (type == 'add') {
      this.costcenterForm.controls['costcenterid'].setValue(0);
      this.costcenterForm.controls['costcenter'].setValue('');
      this.costcenterForm.controls['active'].setValue(1);
    }
    this.costCenterModalRef = this.costcenetrmodalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }
   
}
